import React, { FC } from 'react';
import { ProductsListPageSkeleton } from '../placementProduct/placementProductSkeleton';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

export const PresetConfigurationsProductsPageSkeleton: FC = () => <ProductsListPageSkeleton titleWidth='280px' />;
export const PresetConfigurationsProductPickedPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
